import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/pdf.svg'
import _imports_1 from '@/assets/doc.svg'
import _imports_2 from '@/assets/docx.svg'
import _imports_3 from '@/assets/xls.svg'
import _imports_4 from '@/assets/xlsx.svg'
import _imports_5 from '@/assets/txt.svg'
import _imports_6 from '@/assets/png.svg'
import _imports_7 from '@/assets/jpg.svg'
import _imports_8 from '@/assets/jpeg.svg'
import _imports_9 from '@/assets/csv.svg'
import _imports_10 from '@/assets/zip.svg'
import _imports_11 from '@/assets/mp4.svg'
import _imports_12 from '@/assets/link.svg'
import _imports_13 from '@/assets/editdefault.svg'
import _imports_14 from '@/assets/deleteIcon.svg'
import _imports_15 from '@/assets/sortBy.svg'
import _imports_16 from '@/assets/arrowRight.svg'
import _imports_17 from '@/assets/cancel.svg'


const _hoisted_1 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_2 = { class: "flex-shrink-0" }
const _hoisted_3 = { class: "flex flex-row justify-between items-center" }
const _hoisted_4 = {
  key: 0,
  class: "items-center justify-between flex"
}
const _hoisted_5 = { class: "title flex items-center" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  class: "flex flex-row"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "w-full minheight" }
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = { class: "mainContainer tabStructure flex flex-row w-full bg-white border rounded-sm mt-5 px-5 pr-5 pb-3 pt-5 border-lightgrey" }
const _hoisted_13 = { class: "h-full min-h-0" }
const _hoisted_14 = {
  key: 0,
  class: "overflow-y-auto descriptionToggle"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "flex flex-row" }
const _hoisted_19 = { class: "border-t border-b border-l p-2 header borderwidth w-1/3 border-lightgrey text-sm" }
const _hoisted_20 = { class: "border p-2 header w-1/4 border-lightgrey rounded-tr-md text-sm" }
const _hoisted_21 = { class: "flex flex-row" }
const _hoisted_22 = { class: "border-l border-b p-2 header w-1/4 border-lightgrey" }
const _hoisted_23 = { class: "border-b border-l p-2 borderwidth w-1/3 border-lightgrey text-xs" }
const _hoisted_24 = { class: "border-b border-l p-2 header w-1/4 border-lightgrey" }
const _hoisted_25 = { class: "border-r border-b border-l border-lightgrey w-1/4 text-xs p-2" }
const _hoisted_26 = { class: "flex flex-row" }
const _hoisted_27 = { class: "border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify" }
const _hoisted_28 = { class: "flex flex-row" }
const _hoisted_29 = { class: "border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify" }
const _hoisted_30 = {
  key: 0,
  class: "flex gap-3 flex-wrap"
}
const _hoisted_31 = { class: "pdf w-full rounded-sm" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_34 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_35 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_36 = {
  key: 3,
  src: _imports_3,
  alt: ""
}
const _hoisted_37 = {
  key: 4,
  src: _imports_4,
  alt: ""
}
const _hoisted_38 = {
  key: 5,
  src: _imports_0,
  alt: ""
}
const _hoisted_39 = {
  key: 6,
  src: _imports_5,
  alt: ""
}
const _hoisted_40 = {
  key: 7,
  src: _imports_6,
  alt: ""
}
const _hoisted_41 = {
  key: 8,
  src: _imports_7,
  alt: ""
}
const _hoisted_42 = {
  key: 9,
  src: _imports_8,
  alt: ""
}
const _hoisted_43 = {
  key: 10,
  src: _imports_9,
  alt: ""
}
const _hoisted_44 = {
  key: 11,
  src: _imports_10,
  alt: ""
}
const _hoisted_45 = {
  key: 12,
  src: _imports_11,
  alt: ""
}
const _hoisted_46 = { class: "flex flex-col w-full min-w-0" }
const _hoisted_47 = { class: "ml-2 pb-1" }
const _hoisted_48 = ["title"]
const _hoisted_49 = { class: "flex justify-between w-full" }
const _hoisted_50 = { class: "ml-2 fontSize10PX" }
const _hoisted_51 = { class: "mr-2 fontSize10PX font-semibold" }
const _hoisted_52 = { class: "pdf w-full rounded-sm flex flex-row items-center" }
const _hoisted_53 = ["onClick", "aria-label"]
const _hoisted_54 = { class: "finding-evidence-link-icon__img-wrap" }
const _hoisted_55 = { class: "finding-evidence-link-icon__tooltip" }
const _hoisted_56 = { class: "flex flex-col w-full min-w-0" }
const _hoisted_57 = { class: "ml-2 pb-1" }
const _hoisted_58 = ["title"]
const _hoisted_59 = { class: "flex justify-between w-full" }
const _hoisted_60 = { class: "ml-2 fontSize10PX" }
const _hoisted_61 = { class: "mr-2 fontSize10PX font-semibold" }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { key: 2 }
const _hoisted_64 = { class: "flex flex-row" }
const _hoisted_65 = { class: "border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify rounded-br-md flex items-center" }
const _hoisted_66 = ["title"]
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { class: "flex" }
const _hoisted_70 = { class: "w-6/12" }
const _hoisted_71 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_72 = {
  key: 1,
  class: "mt-1 mb-2 text-sm"
}
const _hoisted_73 = { class: "w-6/12" }
const _hoisted_74 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_75 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_76 = { class: "flex" }
const _hoisted_77 = { class: "w-6/12" }
const _hoisted_78 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_79 = {
  key: 1,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_80 = { class: "w-6/12" }
const _hoisted_81 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_82 = {
  key: 1,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_83 = { class: "flex" }
const _hoisted_84 = { class: "w-6/12" }
const _hoisted_85 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_86 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_87 = { class: "w-6/12" }
const _hoisted_88 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_89 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_90 = { class: "flex flex-row" }
const _hoisted_91 = { class: "w-6/12" }
const _hoisted_92 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_93 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_94 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_95 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_96 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_97 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_98 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_99 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_100 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_101 = { key: 1 }
const _hoisted_102 = { class: "flex mb-1" }
const _hoisted_103 = { class: "w-6/12" }
const _hoisted_104 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_105 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_106 = { class: "w-6/12" }
const _hoisted_107 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_108 = { class: "flex mb-1" }
const _hoisted_109 = { class: "w-6/12" }
const _hoisted_110 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_111 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_112 = { class: "w-6/12" }
const _hoisted_113 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_114 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_115 = { class: "flex mb-1" }
const _hoisted_116 = { class: "w-6/12" }
const _hoisted_117 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_118 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_119 = { class: "w-6/12" }
const _hoisted_120 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_121 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_122 = { class: "w-full" }
const _hoisted_123 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_124 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_125 = { class: "w-full" }
const _hoisted_126 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_127 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_128 = { class: "w-full" }
const _hoisted_129 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_130 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_131 = { class: "w-full" }
const _hoisted_132 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_133 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_134 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_135 = { class: "row flex flex-row w-full" }
const _hoisted_136 = { class: "w-6/12" }
const _hoisted_137 = { class: "w-6/12 leftspacing" }
const _hoisted_138 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_139 = { class: "row flex flex-row w-full" }
const _hoisted_140 = { class: "w-6/12" }
const _hoisted_141 = { class: "w-6/12 leftspacing" }
const _hoisted_142 = { class: "formcontainer upperspacing" }
const _hoisted_143 = { class: "row flex flex-row w-full" }
const _hoisted_144 = { class: "w-3/6" }
const _hoisted_145 = { class: "w-3/6 leftspacing" }
const _hoisted_146 = { key: 0 }
const _hoisted_147 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_148 = { class: "row flex flex-row w-full" }
const _hoisted_149 = { class: "w-6/12" }
const _hoisted_150 = { class: "w-6/12 leftspacing" }
const _hoisted_151 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_152 = { class: "row flex flex-row w-full" }
const _hoisted_153 = { class: "w-6/12" }
const _hoisted_154 = { class: "w-6/12 leftspacing" }
const _hoisted_155 = { class: "formcontainer upperspacing" }
const _hoisted_156 = { class: "row flex flex-row w-full" }
const _hoisted_157 = { class: "w-3/6" }
const _hoisted_158 = { class: "w-3/6 leftspacing" }
const _hoisted_159 = {
  key: 1,
  class: "overflow-y-auto descriptionToggle"
}
const _hoisted_160 = { class: "border-b border-lightgrey flex justify-between pb-2 mb-5" }
const _hoisted_161 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_162 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_163 = { key: 0 }
const _hoisted_164 = { class: "border border-lightgrey bg-moderategrey" }
const _hoisted_165 = { class: "w-full flex flex-row" }
const _hoisted_166 = { class: "w-70 p-3 border-x border-lightgrey text-xs text-justify" }
const _hoisted_167 = { class: "w-15 flex items-center justify-center" }
const _hoisted_168 = { class: "flex justify-around w-full" }
const _hoisted_169 = ["onClick"]
const _hoisted_170 = ["onClick"]
const _hoisted_171 = { class: "border border-lightgrey" }
const _hoisted_172 = { class: "w-full flex flex-row" }
const _hoisted_173 = { class: "w-15 p-3 border-l-4 border-lightgreen header text-base flex items-center justify-center" }
const _hoisted_174 = { class: "w-70 p-3 border-x border-lightgrey text-xs text-justify" }
const _hoisted_175 = { key: 1 }
const _hoisted_176 = { class: "border border-lightgrey bg-moderategrey" }
const _hoisted_177 = { class: "w-full flex flex-row" }
const _hoisted_178 = { class: "w-70 p-3 border-x border-lightgrey text-xs text-justify" }
const _hoisted_179 = { class: "border-b border-x border-lightgrey" }
const _hoisted_180 = { class: "w-full flex flex-row" }
const _hoisted_181 = { class: "w-15 p-3 border-l-4 border-lightgreen header text-base flex items-center justify-center" }
const _hoisted_182 = ["onClick"]
const _hoisted_183 = { class: "w-15 p-3 flex flex-row items-center justify-center" }
const _hoisted_184 = {
  key: 2,
  class: "overflow-y-auto descriptionToggle"
}
const _hoisted_185 = { class: "border-b border-lightgrey flex justify-between pb-2 mb-5" }
const _hoisted_186 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_187 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_188 = { class: "comments" }
const _hoisted_189 = {
  key: 0,
  class: "initials"
}
const _hoisted_190 = {
  key: 1,
  class: "initials"
}
const _hoisted_191 = { class: "w-1/5" }
const _hoisted_192 = { class: "header" }
const _hoisted_193 = { class: "fontSize10PX" }
const _hoisted_194 = { class: "w-4/5 text-xs text-justify" }
const _hoisted_195 = {
  key: 3,
  class: "overflow-y-auto descriptionToggle"
}
const _hoisted_196 = { class: "border-b border-lightgrey flex justify-between pb-2" }
const _hoisted_197 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_198 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_199 = { class: "flex" }
const _hoisted_200 = {
  key: 0,
  class: "initials"
}
const _hoisted_201 = {
  key: 1,
  class: "initials"
}
const _hoisted_202 = { class: "logContainer w-93" }
const _hoisted_203 = { class: "flex mt-1" }
const _hoisted_204 = {
  key: 0,
  class: "font-semibold text-xs"
}
const _hoisted_205 = {
  key: 1,
  class: "font-semibold text-xs"
}
const _hoisted_206 = {
  key: 2,
  class: "mx-2 text-xs"
}
const _hoisted_207 = {
  key: 3,
  class: "mx-2 text-xs"
}
const _hoisted_208 = {
  key: 4,
  class: "mx-2 text-xs"
}
const _hoisted_209 = {
  key: 5,
  class: "font-semibold text-xs"
}
const _hoisted_210 = {
  key: 6,
  class: "font-semibold text-xs"
}
const _hoisted_211 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_212 = {
  key: 0,
  class: "flex"
}
const _hoisted_213 = { class: "text-xs text-justify" }
const _hoisted_214 = {
  key: 1,
  class: "flex flex-row"
}
const _hoisted_215 = {
  key: 0,
  class: "font-semibold text-xs w-18"
}
const _hoisted_216 = {
  key: 1,
  class: "font-semibold text-xs w-18"
}
const _hoisted_217 = {
  key: 2,
  class: "font-semibold text-xs w-18"
}
const _hoisted_218 = { class: "text-xs w-82 text-justify ml-2" }
const _hoisted_219 = {
  key: 2,
  class: "flex"
}
const _hoisted_220 = { class: "mx-2 text-xs text-justify" }
const _hoisted_221 = {
  key: 3,
  class: "flex"
}
const _hoisted_222 = { class: "mx-2 text-xs text-justify" }
const _hoisted_223 = {
  key: 4,
  class: "flex"
}
const _hoisted_224 = { class: "font-normal text-xs text-justify ml-2" }
const _hoisted_225 = {
  key: 5,
  class: "flex"
}
const _hoisted_226 = { key: 6 }
const _hoisted_227 = { class: "flex items-center" }
const _hoisted_228 = { class: "flex ml-4" }
const _hoisted_229 = {
  key: 0,
  class: "mt-1 text-xs"
}
const _hoisted_230 = { class: "font-semibold ml-1" }
const _hoisted_231 = {
  key: 4,
  class: "overflow-y-auto descriptionToggle"
}
const _hoisted_232 = { class: "border-b border-lightgrey flex justify-between pb-2" }
const _hoisted_233 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_234 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_235 = {
  key: 0,
  class: "initials"
}
const _hoisted_236 = {
  key: 1,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_237 = {
  key: 2,
  class: "initials"
}
const _hoisted_238 = {
  key: 3,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_239 = {
  key: 4,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_240 = {
  key: 5,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_241 = {
  key: 6,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_242 = {
  key: 7,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_243 = {
  key: 8,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_244 = { class: "w-20 border taskDetailsRightBar rounded-sm border-lightgrey" }
const _hoisted_245 = { class: "m-3" }
const _hoisted_246 = { key: 0 }
const _hoisted_247 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_248 = {
  key: 1,
  class: "pt-1.5 overflow-y-scroll thirtyWidthToggle"
}
const _hoisted_249 = { class: "flex flex-col" }
const _hoisted_250 = { class: "mt-3" }
const _hoisted_251 = { key: 0 }
const _hoisted_252 = { class: "mt-2" }
const _hoisted_253 = { key: 1 }
const _hoisted_254 = { class: "mt-3" }
const _hoisted_255 = {
  key: 0,
  class: "mt-2 text-sm"
}
const _hoisted_256 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_257 = {
  key: 0,
  class: "mb-3 mt-4"
}
const _hoisted_258 = { class: "mt-3" }
const _hoisted_259 = {
  key: 0,
  class: "mt-2 text-sm"
}
const _hoisted_260 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_261 = { class: "mt-3" }
const _hoisted_262 = {
  key: 0,
  class: "mt-2 text-sm"
}
const _hoisted_263 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_264 = { class: "mt-3" }
const _hoisted_265 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_266 = {
  key: 1,
  class: "mt-2 text-sm"
}
const _hoisted_267 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_268 = { key: 3 }
const _hoisted_269 = {
  key: 4,
  class: "mt-2 text-sm"
}
const _hoisted_270 = { key: 0 }
const _hoisted_271 = {
  key: 5,
  class: "mt-2 text-sm"
}
const _hoisted_272 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_273 = { class: "flex flex-col h-full" }
const _hoisted_274 = { class: "flex-1 overflow-auto" }
const _hoisted_275 = { class: "formcontainer px-4 pb-4 flex flex-col" }
const _hoisted_276 = { class: "row flex flex-row upperspacing" }
const _hoisted_277 = { class: "w-full" }
const _hoisted_278 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_279 = {
  key: 0,
  class: "error-text"
}
const _hoisted_280 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_281 = { class: "flex justify-end items-center mt-2" }
const _hoisted_282 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_283 = { class: "w-full flex flex-row" }
const _hoisted_284 = { class: "w-95 mr-5" }
const _hoisted_285 = ["onUpdate:modelValue"]
const _hoisted_286 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_287 = { class: "w-5" }
const _hoisted_288 = { class: "flex items-center justify-center h-full" }
const _hoisted_289 = ["onClick"]
const _hoisted_290 = { class: "w-1/2 mt-3" }
const _hoisted_291 = ["onUpdate:modelValue", "max"]
const _hoisted_292 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_293 = {
  key: 0,
  class: "flex items-center justify-end pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_294 = ["disabled"]
const _hoisted_295 = {
  key: 1,
  class: "flex items-center justify-end pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_296 = ["disabled"]
const _hoisted_297 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_298 = { class: "flex flex-col h-full" }
const _hoisted_299 = { class: "flex-1 overflow-auto" }
const _hoisted_300 = { class: "popup-business" }
const _hoisted_301 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_302 = { class: "formcontainer flex flex-col" }
const _hoisted_303 = { class: "row flex flex-row upperspacing" }
const _hoisted_304 = { class: "w-1/2" }
const _hoisted_305 = {
  class: "inputboxstyling mt-2",
  disabled: ""
}
const _hoisted_306 = { class: "row flex flex-row upperspacing" }
const _hoisted_307 = { class: "w-full" }
const _hoisted_308 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_309 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_310 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_311 = ["disabled"]
const _hoisted_312 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_313 = { class: "flex flex-col h-full" }
const _hoisted_314 = { class: "flex-1 overflow-auto" }
const _hoisted_315 = { class: "popup-business" }
const _hoisted_316 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_317 = { class: "formcontainer flex flex-col w-full upperspacing" }
const _hoisted_318 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_319 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_320 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_321 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_commentsEditor = _resolveComponent("commentsEditor")!
  const _component_safeHtml = _resolveComponent("safeHtml")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.modalMode ? 'details-in-modal task-details-in-modal' : 'mb-5 mx-5 mt-3')
  }, [
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.modalMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h1", {
                  class: _normalizeClass(_ctx.titleLength > 40? 'table-ellipsis':'')
                }, _toDisplayString(_ctx.presentFindingObject.finding), 3)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6)),
        (_ctx.approvalObj.statusCode == 10401 && _ctx.checkReviewer(_ctx.presentFindingObject.reviewer))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "btnprimary items-center btnPrimaryPadding mr-2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.approveOrReject(10403))),
                disabled: _ctx.clickOnButtonToReject
              }, "Approve", 8, _hoisted_8),
              _createElementVNode("button", {
                class: "btnprimary items-center btnPrimaryPadding",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPopupToReject()))
              }, "Reject")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Tabs, {
              value: _ctx.selectedTabIndex,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
              scrollable: "",
              class: "w-80 pr-5"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_TabList, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                        return (_openBlock(), _createBlock(_component_Tab, {
                          key: tab.id,
                          value: tab.id,
                          onClick: ($event: any) => (_ctx.toggleTabs(tab))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tab.displayName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_TabPanels, { class: "overflow-auto hide-scrollbar" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                      return (_openBlock(), _createBlock(_component_TabPanel, {
                        key: tab.id,
                        value: tab.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            (tab.id == 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _cache[77] || (_cache[77] = _createElementVNode("div", null, null, -1)),
                                  _cache[78] || (_cache[78] = _createElementVNode("div", { class: "border-b border-lightgrey flex justify-between pb-2 mb-5" }, [
                                    _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("p", { class: "header margining" }, "Finding Information")
                                      ])
                                    ]),
                                    _createElementVNode("div")
                                  ], -1)),
                                  (_ctx.tabDataLoading == true)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                          _createVNode(_component_dots_loader)
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, [
                                          _cache[32] || (_cache[32] = _createElementVNode("div", { class: "border-t border-l border-b p-2 header w-1/4 border-lightgrey rounded-tl-md" }, " Finding ID ", -1)),
                                          _createElementVNode("div", _hoisted_19, _toDisplayString(String(_ctx.presentFindingObject.findingId).toUpperCase()), 1),
                                          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "border-t border-b border-l p-2 header w-1/4 border-lightgrey" }, " CR ID ", -1)),
                                          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.presentFindingObject?.complianceDetails?.[0]?.crId != null
                              ? String(_ctx.presentFindingObject.complianceDetails[0].crId).toUpperCase()
                              : 'N/A'), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_21, [
                                          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.getFindingRelatedToFieldLabel(_ctx.presentFindingObject)), 1),
                                          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.getFindingRelatedToDisplay(_ctx.presentFindingObject)), 1),
                                          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.getFindingLinkFieldLabel(_ctx.presentFindingObject)), 1),
                                          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.getFindingLinkDisplay(_ctx.presentFindingObject)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_26, [
                                          _cache[34] || (_cache[34] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey" }, " Finding ", -1)),
                                          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.presentFindingObject.finding), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_28, [
                                          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey flex items-center" }, " Evidence ", -1)),
                                          _createElementVNode("div", _hoisted_29, [
                                            (_ctx.findingFileEvidences.length || _ctx.findingLinkEvidences.length)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.findingFileEvidences, (doc, idx) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: 'finding-file-'+idx
                                                    }, [
                                                      _createElementVNode("div", _hoisted_31, [
                                                        _createElementVNode("a", {
                                                          href: "#",
                                                          onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                          class: "flex w-full flex-row items-center cursor-pointer"
                                                        }, [
                                                          ( _ctx.getFindingEvidenceFileExt(doc)=='pdf')
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_33))
                                                            : _createCommentVNode("", true),
                                                          ( _ctx.getFindingEvidenceFileExt(doc)=='doc')
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_34))
                                                            : _createCommentVNode("", true),
                                                          ( _ctx.getFindingEvidenceFileExt(doc)=='docx')
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                                                            : _createCommentVNode("", true),
                                                          ( _ctx.getFindingEvidenceFileExt(doc)=='xls')
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_36))
                                                            : _createCommentVNode("", true),
                                                          ( _ctx.getFindingEvidenceFileExt(doc)=='xlsx')
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_37))
                                                            : _createCommentVNode("", true),
                                                          ( _ctx.getFindingEvidenceFileExt(doc)=='rtf')
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_38))
                                                            : _createCommentVNode("", true),
                                                          ( _ctx.getFindingEvidenceFileExt(doc)=='txt')
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_39))
                                                            : _createCommentVNode("", true),
                                                          ( _ctx.getFindingEvidenceFileExt(doc)=='png')
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_40))
                                                            : _createCommentVNode("", true),
                                                          ( _ctx.getFindingEvidenceFileExt(doc)=='jpg')
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_41))
                                                            : _createCommentVNode("", true),
                                                          ( _ctx.getFindingEvidenceFileExt(doc)=='jpeg')
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_42))
                                                            : _createCommentVNode("", true),
                                                          ( _ctx.getFindingEvidenceFileExt(doc)=='csv')
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_43))
                                                            : _createCommentVNode("", true),
                                                          ( _ctx.getFindingEvidenceFileExt(doc)=='zip')
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_44))
                                                            : _createCommentVNode("", true),
                                                          ( _ctx.getFindingEvidenceFileExt(doc)=='mp4')
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_45))
                                                            : _createCommentVNode("", true),
                                                          _createElementVNode("div", _hoisted_46, [
                                                            _createElementVNode("div", _hoisted_47, [
                                                              _createElementVNode("p", {
                                                                class: "text-xs font-medium truncate",
                                                                title: doc.filename || doc.name
                                                              }, _toDisplayString(doc.filename || doc.name || 'N/A'), 9, _hoisted_48)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_49, [
                                                              _createElementVNode("p", _hoisted_50, _toDisplayString(doc.evidenceDate?_ctx.formatFileAttachedTime(doc.evidenceDate):'N/A'), 1),
                                                              _createElementVNode("p", _hoisted_51, _toDisplayString(doc.taskId?doc.taskId:'N/A'), 1)
                                                            ])
                                                          ])
                                                        ], 8, _hoisted_32)
                                                      ])
                                                    ]))
                                                  }), 128)),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.findingLinkEvidences, (doc, idx) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: 'finding-link-'+idx
                                                    }, [
                                                      _createElementVNode("div", _hoisted_52, [
                                                        _createElementVNode("a", {
                                                          href: "#",
                                                          onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                          class: "finding-evidence-link-icon cursor-pointer",
                                                          "aria-label": doc.url
                                                        }, [
                                                          _createElementVNode("span", _hoisted_54, [
                                                            _cache[35] || (_cache[35] = _createElementVNode("img", {
                                                              src: _imports_12,
                                                              alt: "Link",
                                                              class: "finding-evidence-link-icon__img"
                                                            }, null, -1)),
                                                            _createElementVNode("span", _hoisted_55, _toDisplayString(doc.url), 1)
                                                          ])
                                                        ], 8, _hoisted_53),
                                                        _createElementVNode("div", _hoisted_56, [
                                                          _createElementVNode("div", _hoisted_57, [
                                                            _createElementVNode("p", {
                                                              class: "text-xs font-medium truncate",
                                                              title: doc.filename || doc.name
                                                            }, _toDisplayString(doc.filename || doc.name || 'N/A'), 9, _hoisted_58)
                                                          ]),
                                                          _createElementVNode("div", _hoisted_59, [
                                                            _createElementVNode("p", _hoisted_60, _toDisplayString(doc.evidenceDate?_ctx.formatFileAttachedTime(doc.evidenceDate):'N/A'), 1),
                                                            _createElementVNode("p", _hoisted_61, _toDisplayString(doc.taskId?doc.taskId:'N/A'), 1)
                                                          ])
                                                        ])
                                                      ])
                                                    ]))
                                                  }), 128))
                                                ]))
                                              : (_ctx.presentFindingObject.findingEvidence)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(_ctx.presentFindingObject.findingEvidence), 1))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_63, "N/A"))
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_64, [
                                          _cache[37] || (_cache[37] = _createElementVNode("div", { class: "border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md flex items-center" }, " Finding Severity ", -1)),
                                          _createElementVNode("div", _hoisted_65, [
                                            (_ctx.getFindingSeverityValue(_ctx.presentFindingObject) != null)
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular whitespace-nowrap overflow-hidden", _ctx.findingSeverityChipBg(_ctx.presentFindingObject)]),
                                                  title: _ctx.getFindingSeverityLabel(_ctx.presentFindingObject)
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["truncate whitespace-nowrap", _ctx.findingSeverityChipText(_ctx.presentFindingObject)])
                                                  }, _toDisplayString(_ctx.getFindingSeverityLabel(_ctx.presentFindingObject)), 3)
                                                ], 10, _hoisted_66))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_67, "N/A"))
                                          ])
                                        ]),
                                        (_ctx.presentFindingObject.complianceDetails[0]?.clientUniqueId && _ctx.presentFindingObject.complianceDetails[0]?.clientUniqueId!=null)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                              _createElementVNode("div", null, [
                                                _cache[40] || (_cache[40] = _createElementVNode("div", null, [
                                                  _createElementVNode("div", { class: "border-b border-lightgrey" }, [
                                                    _createElementVNode("p", { class: "mt-4 mb-1.5 header" }, "Control Information")
                                                  ])
                                                ], -1)),
                                                _createElementVNode("div", _hoisted_69, [
                                                  _createElementVNode("div", _hoisted_70, [
                                                    _cache[38] || (_cache[38] = _createElementVNode("p", { class: "font-extrabold mt-2.5 mb-1 text-xs" }, "CID", -1)),
                                                    (_ctx.presentFindingObject && _ctx.presentFindingObject!=undefined && _ctx.presentFindingObject.complianceDetails && _ctx.presentFindingObject.complianceDetails.length>0&& _ctx.presentFindingObject.complianceDetails[0]?.clientUniqueId!=undefined)
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_71, _toDisplayString(_ctx.presentFindingObject.complianceDetails!=undefined&&_ctx.presentFindingObject.complianceDetails[0]?.clientUniqueId!='' ? _ctx.presentFindingObject.complianceDetails[0]?.clientUniqueId : 'N/A'), 1))
                                                      : (_openBlock(), _createElementBlock("p", _hoisted_72, "N/A"))
                                                  ]),
                                                  _createElementVNode("div", _hoisted_73, [
                                                    _cache[39] || (_cache[39] = _createElementVNode("p", { class: "font-extrabold mt-2.5 mb-1 text-xs" }, "Frequency", -1)),
                                                    (_ctx.presentFindingObject && _ctx.presentFindingObject !=undefined && _ctx.presentFindingObject.complianceDetails && _ctx.presentFindingObject.complianceDetails[0]?.controlFrequency!=undefined)
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_74, _toDisplayString(_ctx.dbFrequency.find((l) => l.value == _ctx.presentFindingObject.complianceDetails[0]?.controlFrequency)?.key), 1))
                                                      : (_openBlock(), _createElementBlock("p", _hoisted_75, "N/A"))
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_76, [
                                                _createElementVNode("div", _hoisted_77, [
                                                  _cache[41] || (_cache[41] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Title", -1)),
                                                  (_ctx.presentFindingObject && _ctx.presentFindingObject !=undefined && _ctx.presentFindingObject.complianceDetails &&_ctx.presentFindingObject.complianceDetails.length>0 && _ctx.presentFindingObject.complianceDetails[0]?.controlTitle!=undefined )
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_78, _toDisplayString(_ctx.presentFindingObject.complianceDetails[0].controlTitle), 1))
                                                    : (_openBlock(), _createElementBlock("p", _hoisted_79, "N/A"))
                                                ]),
                                                _createElementVNode("div", _hoisted_80, [
                                                  _cache[42] || (_cache[42] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Type", -1)),
                                                  (_ctx.presentFindingObject && _ctx.presentFindingObject !=undefined && _ctx.presentFindingObject.complianceDetails &&_ctx.presentFindingObject.complianceDetails.length>0 && _ctx.presentFindingObject.complianceDetails[0]?.controlType!=undefined )
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_81, _toDisplayString(_ctx.presentFindingObject.complianceDetails[0]?.controlType||'N/A'), 1))
                                                    : (_openBlock(), _createElementBlock("p", _hoisted_82, "N/A"))
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_83, [
                                                _createElementVNode("div", _hoisted_84, [
                                                  _cache[43] || (_cache[43] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Class", -1)),
                                                  (_ctx.presentFindingObject && _ctx.presentFindingObject!=undefined && _ctx.presentFindingObject.complianceDetails && _ctx.presentFindingObject.complianceDetails.length>0&& _ctx.presentFindingObject.complianceDetails[0]?.controlClass!=undefined)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_85, _toDisplayString(_ctx.presentFindingObject.complianceDetails[0].controlClass||'N/A'), 1))
                                                    : (_openBlock(), _createElementBlock("p", _hoisted_86, "N/A"))
                                                ]),
                                                _createElementVNode("div", _hoisted_87, [
                                                  _cache[44] || (_cache[44] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Family", -1)),
                                                  (_ctx.presentFindingObject && _ctx.presentFindingObject!=undefined && _ctx.presentFindingObject.complianceDetails && _ctx.presentFindingObject.complianceDetails.length>0&& _ctx.presentFindingObject.complianceDetails[0]?.controlFamily!=undefined)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_88, _toDisplayString(_ctx.presentFindingObject.complianceDetails[0].controlFamily||'N/A'), 1))
                                                    : (_openBlock(), _createElementBlock("p", _hoisted_89, "N/A"))
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_90, [
                                                _createElementVNode("div", _hoisted_91, [
                                                  _cache[45] || (_cache[45] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Priority", -1)),
                                                  (_ctx.presentFindingObject && _ctx.presentFindingObject!=undefined && _ctx.presentFindingObject.complianceDetails && _ctx.presentFindingObject.complianceDetails.length>0&& _ctx.presentFindingObject.complianceDetails[0]?.controlPriority!=undefined && typeof _ctx.presentFindingObject.complianceDetails[0]?.controlPriority === 'number')
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2 mb-3", _ctx.colorLabelBg(_ctx.presentFindingObject.complianceDetails[0]?.controlPriority)])
                                                      }, [
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.presentFindingObject.complianceDetails[0]?.controlPriority)])
                                                        }, _toDisplayString(_ctx.getProirityLabel(_ctx.presentFindingObject.complianceDetails[0]?.controlPriority)), 3)
                                                      ], 2))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_92, "N/A"))
                                                ])
                                              ]),
                                              _createElementVNode("div", null, [
                                                _cache[46] || (_cache[46] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Description", -1)),
                                                (_ctx.presentFindingObject && _ctx.presentFindingObject!=undefined && _ctx.presentFindingObject.complianceDetails && _ctx.presentFindingObject.complianceDetails.length>0&& _ctx.presentFindingObject.complianceDetails[0]?.Description!=undefined)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_93, _toDisplayString(_ctx.presentFindingObject.complianceDetails[0]?.Description||'N/A'), 1))
                                                  : (_openBlock(), _createElementBlock("p", _hoisted_94, "N/A"))
                                              ]),
                                              _createElementVNode("div", null, [
                                                _cache[47] || (_cache[47] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Policy/Procedure", -1)),
                                                (_ctx.presentFindingObject && _ctx.presentFindingObject!=undefined && _ctx.presentFindingObject.complianceDetails && _ctx.presentFindingObject.complianceDetails.length>0&& _ctx.presentFindingObject.complianceDetails[0]?.controlPolicies!=undefined)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_95, _toDisplayString(_ctx.presentFindingObject.complianceDetails[0].controlPolicies||'N/A'), 1))
                                                  : (_openBlock(), _createElementBlock("p", _hoisted_96, "N/A"))
                                              ]),
                                              _createElementVNode("div", null, [
                                                _cache[48] || (_cache[48] = _createElementVNode("label", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Guidance", -1)),
                                                (_ctx.presentFindingObject && _ctx.presentFindingObject!=undefined && _ctx.presentFindingObject.complianceDetails && _ctx.presentFindingObject.complianceDetails.length>0&& _ctx.presentFindingObject.complianceDetails[0]?.controlGuidance!=undefined)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_97, _toDisplayString(_ctx.presentFindingObject.complianceDetails[0].controlGuidance||'N/A'), 1))
                                                  : (_openBlock(), _createElementBlock("p", _hoisted_98, "N/A"))
                                              ]),
                                              _createElementVNode("div", null, [
                                                _cache[49] || (_cache[49] = _createElementVNode("label", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Task", -1)),
                                                (_ctx.presentFindingObject && _ctx.presentFindingObject!=undefined && _ctx.presentFindingObject.complianceDetails && _ctx.presentFindingObject.complianceDetails.length>0&& _ctx.presentFindingObject.complianceDetails[0]?.controlMaintenanceTask!=undefined)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_99, _toDisplayString(_ctx.presentFindingObject.complianceDetails[0].controlMaintenanceTask||'N/A'), 1))
                                                  : (_openBlock(), _createElementBlock("p", _hoisted_100, "N/A"))
                                              ])
                                            ]))
                                          : (_ctx.presentFindingObject?.riskInformation && _ctx.presentFindingObject?.riskInformation.length>0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                                _createElementVNode("div", null, [
                                                  _cache[60] || (_cache[60] = _createElementVNode("div", null, [
                                                    _createElementVNode("div", { class: "border-b border-lightgrey" }, [
                                                      _createElementVNode("p", { class: "mt-4 mb-1.5 header" }, "Risk Information")
                                                    ])
                                                  ], -1)),
                                                  _createElementVNode("div", _hoisted_102, [
                                                    _createElementVNode("div", _hoisted_103, [
                                                      _cache[50] || (_cache[50] = _createElementVNode("p", { class: "font-extrabold mt-3 mb-1 text-xs" }, "Risk", -1)),
                                                      ((_ctx.presentFindingObject?.riskInformation[0]?.risk||'N/A'))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_104, _toDisplayString(_ctx.presentFindingObject?.riskInformation[0]?.risk ||'N/A'), 1))
                                                        : (_openBlock(), _createElementBlock("p", _hoisted_105, "N/A"))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_106, [
                                                      _cache[51] || (_cache[51] = _createElementVNode("p", { class: "font-extrabold mt-3 mb-1 text-xs" }, "Priority", -1)),
                                                      (_ctx.presentFindingObject?.riskInformation[0]?.priority && typeof _ctx.presentFindingObject?.riskInformation[0]?.priority === 'number')
                                                        ? (_openBlock(), _createElementBlock("div", {
                                                            key: 0,
                                                            class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2 mb-3", _ctx.colorLabelBg(_ctx.presentFindingObject?.riskInformation[0]?.priority)])
                                                          }, [
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.presentFindingObject?.riskInformation[0]?.priority)])
                                                            }, _toDisplayString(_ctx.getProirityLabel(_ctx.presentFindingObject?.riskInformation[0]?.priority)), 3)
                                                          ], 2))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_107, "N/A"))
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_108, [
                                                    _createElementVNode("div", _hoisted_109, [
                                                      _cache[52] || (_cache[52] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Risk Category", -1)),
                                                      ((_ctx.presentFindingObject?.riskInformation[0]?.riskCategory))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_110, _toDisplayString(_ctx.presentFindingObject?.riskInformation[0]?.riskCategory||'N/A'), 1))
                                                        : (_openBlock(), _createElementBlock("p", _hoisted_111, "N/A"))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_112, [
                                                      _cache[53] || (_cache[53] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Risk Owner", -1)),
                                                      ((_ctx.presentFindingObject?.riskInformation[0]?.riskOwner))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_113, _toDisplayString(_ctx.getRiskOwnerLabel(_ctx.presentFindingObject?.riskInformation[0]?.riskOwner)||'N/A'), 1))
                                                        : (_openBlock(), _createElementBlock("p", _hoisted_114, "N/A"))
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_115, [
                                                    _createElementVNode("div", _hoisted_116, [
                                                      _cache[54] || (_cache[54] = _createElementVNode("p", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Threat Category", -1)),
                                                      ((_ctx.presentFindingObject?.riskInformation[0]?.threatCategory))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_117, _toDisplayString(_ctx.presentFindingObject?.riskInformation[0]?.threatCategory||'N/A'), 1))
                                                        : (_openBlock(), _createElementBlock("p", _hoisted_118, "N/A"))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_119, [
                                                      _cache[55] || (_cache[55] = _createElementVNode("label", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Threat Source", -1)),
                                                      ((_ctx.presentFindingObject?.riskInformation[0]?.threatSource))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_120, _toDisplayString(_ctx.presentFindingObject?.riskInformation[0]?.threatSource||'N/A'), 1))
                                                        : (_openBlock(), _createElementBlock("p", _hoisted_121, "N/A"))
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_122, [
                                                    _cache[56] || (_cache[56] = _createElementVNode("p", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Threat", -1)),
                                                    ((_ctx.presentFindingObject?.riskInformation[0]?.threatEvent))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_123, _toDisplayString(_ctx.presentFindingObject?.riskInformation[0]?.threatEvent||'N/A'), 1))
                                                      : (_openBlock(), _createElementBlock("p", _hoisted_124, "N/A"))
                                                  ]),
                                                  _createElementVNode("div", _hoisted_125, [
                                                    _cache[57] || (_cache[57] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Vulnerability", -1)),
                                                    ((_ctx.presentFindingObject?.riskInformation[0]?.vulnerability))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_126, _toDisplayString(_ctx.presentFindingObject?.riskInformation[0]?.vulnerability||'N/A'), 1))
                                                      : (_openBlock(), _createElementBlock("p", _hoisted_127, "N/A"))
                                                  ]),
                                                  _createElementVNode("div", _hoisted_128, [
                                                    _cache[58] || (_cache[58] = _createElementVNode("p", { class: "font-extrabold mb-2 text-xs" }, "Risk Assessment", -1)),
                                                    ((_ctx.presentFindingObject?.riskInformation[0]?.riskAssessment!=''))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_129, _toDisplayString(_ctx.presentFindingObject?.riskInformation[0]?.riskAssessment||'N/A'), 1))
                                                      : (_openBlock(), _createElementBlock("p", _hoisted_130, "N/A"))
                                                  ]),
                                                  _createElementVNode("div", _hoisted_131, [
                                                    _cache[59] || (_cache[59] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Treatment Summary", -1)),
                                                    ((_ctx.presentFindingObject?.riskInformation[0]?.action!=''))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_132, _toDisplayString(_ctx.treatmentSummaryData(_ctx.presentFindingObject?.riskInformation[0]?.action)||'N/A'), 1))
                                                      : (_openBlock(), _createElementBlock("p", _hoisted_133, "N/A"))
                                                  ])
                                                ]),
                                                _createElementVNode("div", null, [
                                                  _cache[67] || (_cache[67] = _createElementVNode("h1", { class: "upperspacing" }, "Inherited Risk", -1)),
                                                  _cache[68] || (_cache[68] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                                  _createElementVNode("div", _hoisted_134, [
                                                    _createElementVNode("div", _hoisted_135, [
                                                      _createElementVNode("div", _hoisted_136, [
                                                        _cache[61] || (_cache[61] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingObject?.riskInformation[0]?.business)])
                                                        }, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingObject?.riskInformation[0]?.business))
                                                          }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingObject?.riskInformation[0]?.business,1)||'N/A'), 3)
                                                        ], 2)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_137, [
                                                        _cache[62] || (_cache[62] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingObject?.riskInformation[0]?.financial)])
                                                        }, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingObject?.riskInformation[0]?.financial))
                                                          }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingObject?.riskInformation[0]?.financial,2)||'N/A'), 3)
                                                        ], 2)
                                                      ])
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_138, [
                                                    _createElementVNode("div", _hoisted_139, [
                                                      _createElementVNode("div", _hoisted_140, [
                                                        _cache[63] || (_cache[63] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingObject?.riskInformation[0]?.operations)])
                                                        }, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingObject?.riskInformation[0]?.operations))
                                                          }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingObject?.riskInformation[0]?.operations,3)||'N/A'), 3)
                                                        ], 2)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_141, [
                                                        _cache[64] || (_cache[64] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingObject?.riskInformation[0]?.legal)])
                                                        }, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingObject?.riskInformation[0]?.legal))
                                                          }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingObject?.riskInformation[0]?.legal,4)||'N/A'), 3)
                                                        ], 2)
                                                      ])
                                                    ])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_142, [
                                                    _createElementVNode("div", _hoisted_143, [
                                                      _createElementVNode("div", _hoisted_144, [
                                                        _cache[65] || (_cache[65] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingObject?.riskInformation[0]?.likelihood)])
                                                        }, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingObject?.riskInformation[0]?.likelihood))
                                                          }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingObject?.riskInformation[0]?.likelihood,5)||'N/A'), 3)
                                                        ], 2)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_145, [
                                                        _cache[66] || (_cache[66] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingObject?.riskInformation[0]?.overallImpact)])
                                                        }, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingObject?.riskInformation[0]?.overallImpact))
                                                          }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingObject?.riskInformation[0]?.overallImpact,6)||'N/A'), 3)
                                                        ], 2)
                                                      ])
                                                    ])
                                                  ])
                                                ]),
                                                (_ctx.presentFindingObject?.riskInformation[0]?.action && _ctx.presentFindingObject?.riskInformation[0]?.action!=10419)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                                      _cache[75] || (_cache[75] = _createElementVNode("h1", { class: "upperspacing" }, "Residual Risk", -1)),
                                                      _cache[76] || (_cache[76] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                                      _createElementVNode("div", _hoisted_147, [
                                                        _createElementVNode("div", _hoisted_148, [
                                                          _createElementVNode("div", _hoisted_149, [
                                                            _cache[69] || (_cache[69] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingObject?.riskInformation[0]?.residual?.[0]?.business)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingObject?.riskInformation[0]?.residual?.[0]?.business))
                                                              }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingObject?.riskInformation[0]?.residual?.[0]?.business,1)||'N/A'), 3)
                                                            ], 2)
                                                          ]),
                                                          _createElementVNode("div", _hoisted_150, [
                                                            _cache[70] || (_cache[70] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingObject?.riskInformation[0]?.residual?.[0]?.financial)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingObject?.riskInformation[0]?.residual?.[0]?.financial))
                                                              }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingObject?.riskInformation[0]?.residual?.[0]?.financial,2)||'N/A'), 3)
                                                            ], 2)
                                                          ])
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_151, [
                                                        _createElementVNode("div", _hoisted_152, [
                                                          _createElementVNode("div", _hoisted_153, [
                                                            _cache[71] || (_cache[71] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingObject?.riskInformation[0]?.residual?.[0]?.operations)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingObject?.riskInformation[0]?.residual?.[0]?.operations))
                                                              }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingObject?.riskInformation[0]?.residual?.[0]?.operations,3)||'N/A'), 3)
                                                            ], 2)
                                                          ]),
                                                          _createElementVNode("div", _hoisted_154, [
                                                            _cache[72] || (_cache[72] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingObject?.riskInformation[0]?.residual?.[0]?.legal)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingObject?.riskInformation[0]?.residual?.[0]?.legal))
                                                              }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingObject?.riskInformation[0]?.residual?.[0]?.legal,4)||'N/A'), 3)
                                                            ], 2)
                                                          ])
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_155, [
                                                        _createElementVNode("div", _hoisted_156, [
                                                          _createElementVNode("div", _hoisted_157, [
                                                            _cache[73] || (_cache[73] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingObject?.riskInformation[0]?.residual?.[0]?.likelihood)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingObject?.riskInformation[0]?.residual?.[0]?.likelihood))
                                                              }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingObject?.riskInformation[0]?.residual?.[0]?.likelihood,5)||'N/A'), 3)
                                                            ], 2)
                                                          ]),
                                                          _createElementVNode("div", _hoisted_158, [
                                                            _cache[74] || (_cache[74] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.bgColor(_ctx.presentFindingObject?.riskInformation[0]?.overallImpact)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(_ctx.colorLabel(_ctx.presentFindingObject?.riskInformation[0]?.overallImpact))
                                                              }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentFindingObject?.riskInformation[0]?.overallImpact,6)||'N/A'), 3)
                                                            ], 2)
                                                          ])
                                                        ])
                                                      ])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true)
                                      ]))
                                ]))
                              : _createCommentVNode("", true),
                            (tab.id == 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_160, [
                                      _cache[79] || (_cache[79] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("p", { class: "header" }, "Causes & Actions")
                                        ])
                                      ], -1)),
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_161, [
                                          _createElementVNode("div", _hoisted_162, [
                                            _createElementVNode("button", {
                                              class: _normalizeClass(_ctx.TaskDetailsDropDown.findingStatus == 10418 || _ctx.approvalObj.statusCode == 10403 || !_ctx.isAddDisabled(10302) ? 'btndisabled  pointer-events-none' : 'filterButton' ),
                                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openCausePopup()))
                                            }, " Add Cause ", 2)
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]),
                                  (_ctx.presentFindingObject.causes != undefined  && _ctx.presentFindingObject.tasks == undefined)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentFindingObject.causes, (cause, number) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: "mb-3",
                                            key: number
                                          }, [
                                            _createElementVNode("div", _hoisted_164, [
                                              _createElementVNode("div", _hoisted_165, [
                                                _cache[80] || (_cache[80] = _createElementVNode("div", { class: "w-15 p-3 border-l-4 border-darkred header text-base flex items-center justify-center" }, "Cause for this Finding ", -1)),
                                                _createElementVNode("div", _hoisted_166, _toDisplayString(_ctx.presentFindingObject.causes[number].cause), 1),
                                                _createElementVNode("div", _hoisted_167, [
                                                  _createElementVNode("div", _hoisted_168, [
                                                    _createElementVNode("img", {
                                                      src: _imports_13,
                                                      class: "cursor-pointer",
                                                      onClick: ($event: any) => (_ctx.editCauseAndAction(cause))
                                                    }, null, 8, _hoisted_169),
                                                    _createElementVNode("img", {
                                                      src: _imports_14,
                                                      class: "cursor-pointer",
                                                      onClick: ($event: any) => (_ctx.deleteCauseAndAction(cause.causeId, cause.cause))
                                                    }, null, 8, _hoisted_170)
                                                  ])
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("ul", null, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cause.actions, (action, index) => {
                                                return (_openBlock(), _createElementBlock("li", { key: index }, [
                                                  _createElementVNode("div", _hoisted_171, [
                                                    _createElementVNode("div", _hoisted_172, [
                                                      _createElementVNode("div", _hoisted_173, "Action" + _toDisplayString(index + 1) + " for this Finding ", 1),
                                                      _createElementVNode("div", _hoisted_174, _toDisplayString(action.action), 1),
                                                      _cache[81] || (_cache[81] = _createElementVNode("div", { class: "w-15 p-3 flex flex-row items-center justify-center" }, [
                                                        _createElementVNode("div", { class: "flex items-center justify-center rounded h-5 w-full bg-lightgrey border-solid border border-disabledgrey" }, [
                                                          _createElementVNode("div", { class: "font-semibold text-xs text-disabledgrey" }, " Not Started ")
                                                        ])
                                                      ], -1))
                                                    ])
                                                  ])
                                                ]))
                                              }), 128))
                                            ])
                                          ]))
                                        }), 128))
                                      ]))
                                    : (_ctx.presentFindingObject.tasks != undefined)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.finalFindingsTasks, (task, number) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: "mb-3",
                                              key: number
                                            }, [
                                              _createElementVNode("div", _hoisted_176, [
                                                _createElementVNode("div", _hoisted_177, [
                                                  _cache[82] || (_cache[82] = _createElementVNode("div", { class: "w-15 p-3 border-l-4 border-darkred header text-base flex items-center justify-center" }, "Cause for this Finding ", -1)),
                                                  _createElementVNode("div", _hoisted_178, _toDisplayString(number), 1),
                                                  _cache[83] || (_cache[83] = _createElementVNode("div", { class: "w-15 flex items-center justify-center p-3" }, [
                                                    _createElementVNode("div", { class: "flex items-center justify-center rounded h-5 w-full evidenceUpload border-solid border border-primary" }, [
                                                      _createElementVNode("div", { class: "font-semibold text-xs text-primary" }, " Approved ")
                                                    ])
                                                  ], -1))
                                                ])
                                              ]),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(task, (task1, num) => {
                                                return (_openBlock(), _createElementBlock("div", { key: num }, [
                                                  _createElementVNode("ul", null, [
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("div", _hoisted_179, [
                                                        _createElementVNode("div", _hoisted_180, [
                                                          _createElementVNode("div", _hoisted_181, "Action" + _toDisplayString(num + 1) + " for this Finding", 1),
                                                          _createElementVNode("div", {
                                                            class: "w-70 p-3 border-x border-lightgrey text-xs text-justify cursor-pointer",
                                                            onClick: ($event: any) => (_ctx.goToActionTasks(task1._id))
                                                          }, _toDisplayString(task1.action), 9, _hoisted_182),
                                                          _createElementVNode("div", _hoisted_183, [
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-full", _ctx.colorFindingBg(task1.statusCode)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(["text-xs", _ctx.colorFindingText(task1.statusCode)])
                                                              }, _toDisplayString(_ctx.getStatusLabel(task1.statusCode)), 3)
                                                            ], 2)
                                                          ])
                                                        ])
                                                      ])
                                                    ])
                                                  ])
                                                ]))
                                              }), 128))
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (tab.id == 3)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_185, [
                                      _cache[86] || (_cache[86] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("p", { class: "header" }, "Comments")
                                        ])
                                      ], -1)),
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_186, [
                                          _createElementVNode("div", _hoisted_187, [
                                            (_ctx.oldComments)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  class: _normalizeClass(["filterButton flex", Object.keys(this.presentFindingObject).includes('comments') && this.presentFindingObject.comments.length != 0 ? 'filterButton' : 'btndisabled pointer-events-none']),
                                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortComments()))
                                                }, _cache[84] || (_cache[84] = [
                                                  _createElementVNode("img", {
                                                    src: _imports_15,
                                                    class: "h-3 mr-2.5"
                                                  }, null, -1),
                                                  _createTextVNode(" Oldest ")
                                                ]), 2))
                                              : _createCommentVNode("", true),
                                            (!_ctx.oldComments)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 1,
                                                  class: "filterButton flex",
                                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortComments()))
                                                }, _cache[85] || (_cache[85] = [
                                                  _createElementVNode("img", {
                                                    src: _imports_15,
                                                    class: "h-3 mr-2.5 rotate-180"
                                                  }, null, -1),
                                                  _createTextVNode(" Newest ")
                                                ])))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", null, [
                                      (_ctx.TaskDetailsDropDown.findingStatus!=10403 && _ctx.TaskDetailsDropDown.findingStatus!=10418 && _ctx.isAddDisabled(10302))
                                        ? (_openBlock(), _createBlock(_component_commentsEditor, {
                                            key: 0,
                                            taskStatusCode: _ctx.TaskDetailsDropDown.findingStatus
                                          }, null, 8, ["taskStatusCode"]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_188, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentFindingObject.comments, (obj, number) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: number,
                                            class: "border border-lightgrey mt-2 rounded-sm flex flex-row p-3"
                                          }, [
                                            (Object.keys(obj).includes('createdBy'))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_189, _toDisplayString(_ctx.extractInitials(_ctx.getPersonName(obj.createdBy))), 1))
                                              : _createCommentVNode("", true),
                                            (Object.keys(obj).includes('updatedBy'))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_190, _toDisplayString(_ctx.extractInitials(_ctx.getPersonName(obj.updatedBy))), 1))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_191, [
                                              _createElementVNode("div", _hoisted_192, _toDisplayString(_ctx.getPersonName(obj.createdBy)), 1),
                                              _createElementVNode("div", _hoisted_193, _toDisplayString(obj.createdAt), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_194, [
                                              _createVNode(_component_safeHtml, {
                                                content: obj.comment
                                              }, null, 8, ["content"])
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (tab.id == 5)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_196, [
                                      _cache[89] || (_cache[89] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("p", { class: "header" }, "WorkLog")
                                        ])
                                      ], -1)),
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_197, [
                                          _createElementVNode("div", _hoisted_198, [
                                            (_ctx.oldHistory)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  class: _normalizeClass(["filterButton flex", Object.keys(this.workLogObject).includes('findingHistory') && this.workLogObject.findingHistory.length != 0 ? 'filterButton' : 'btndisabled pointer-events-none']),
                                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortHistory()))
                                                }, _cache[87] || (_cache[87] = [
                                                  _createElementVNode("img", {
                                                    src: _imports_15,
                                                    class: "h-3 mr-2.5"
                                                  }, null, -1),
                                                  _createTextVNode(" Oldest ")
                                                ]), 2))
                                              : _createCommentVNode("", true),
                                            (!_ctx.oldHistory)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 1,
                                                  class: "filterButton flex",
                                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sortHistory()))
                                                }, _cache[88] || (_cache[88] = [
                                                  _createElementVNode("img", {
                                                    src: _imports_15,
                                                    class: "h-3 mr-2.5 rotate-180"
                                                  }, null, -1),
                                                  _createTextVNode(" Newest ")
                                                ])))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workLogObject.findingHistory, (work) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: work,
                                        class: "bg-white py-4 mb-0.5 border-lightgrey border-b w-full"
                                      }, [
                                        _createElementVNode("div", _hoisted_199, [
                                          (Object.keys(work).includes('createdBy'))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_200, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                            : _createCommentVNode("", true),
                                          (Object.keys(work).includes('updatedBy'))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_201, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_202, [
                                            _createElementVNode("div", _hoisted_203, [
                                              (Object.keys(work).includes('createdBy'))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_204, _toDisplayString(work.name), 1))
                                                : (Object.keys(work).includes('updatedBy'))
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_205, _toDisplayString(work.name), 1))
                                                  : _createCommentVNode("", true),
                                              (work.actionEntity == 10301)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_206, _toDisplayString('Created the Finding on')))
                                                : (work.statusCode != undefined && work.statusCode == 10418)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_207, _toDisplayString('Terminated the Finding on')))
                                                  : (work.actionEntity == 10302)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_208, _toDisplayString('Updated the Finding on')))
                                                    : _createCommentVNode("", true),
                                              (Object.keys(work).includes('createdAt'))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_209, _toDisplayString(_ctx.formatTime(work.createdAt)), 1))
                                                : _createCommentVNode("", true),
                                              (Object.keys(work).includes('updatedAt'))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_210, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            (Object.keys(work).includes('additionalInfo'))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                                                  (work.additionalInfo.comment)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_212, [
                                                        _cache[90] || (_cache[90] = _createElementVNode("div", { class: "font-semibold text-xs pr-2" }, "Comment:", -1)),
                                                        _createElementVNode("div", _hoisted_213, [
                                                          _createVNode(_component_safeHtml, {
                                                            content: work.additionalInfo.comment
                                                          }, null, 8, ["content"])
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (work.additionalInfo.cause)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_214, [
                                                        (work.additionalInfo.action == 10301)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_215, "Created the Cause :"))
                                                          : (work.additionalInfo.action == 10302)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_216, "Updated the Cause :"))
                                                            : (work.additionalInfo.action == 10303)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_217, "Deleted the Cause :"))
                                                              : _createCommentVNode("", true),
                                                        _createElementVNode("div", _hoisted_218, _toDisplayString(work.additionalInfo.cause), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (Object.keys(work.additionalInfo).includes('assignee'))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_219, [
                                                        _cache[91] || (_cache[91] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Assigned the Task To -'), -1)),
                                                        _createElementVNode("p", _hoisted_220, _toDisplayString(work.additionalInfo.name), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (Object.keys(work.additionalInfo).includes('approver'))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_221, [
                                                        _cache[92] || (_cache[92] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Sent Approval for -'), -1)),
                                                        _createElementVNode("p", _hoisted_222, _toDisplayString(_ctx.getPersonName(work.additionalInfo.approver)), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (work.additionalInfo.approvalStatusCode == 10410)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_223, [
                                                        _cache[93] || (_cache[93] = _createElementVNode("p", { class: "font-semibold text-xs text-justify" }, _toDisplayString('Approval is Rejected :'), -1)),
                                                        _createElementVNode("p", _hoisted_224, _toDisplayString(work.additionalInfo.justification), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (work.additionalInfo.approvalStatusCode == 10403)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_225, _cache[94] || (_cache[94] = [
                                                        _createElementVNode("p", { class: "font-semibold text-xs text-justify" }, _toDisplayString('Approval is Accepted'), -1)
                                                      ])))
                                                    : _createCommentVNode("", true),
                                                  (Object.keys(work.additionalInfo).includes('previousStatus'))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_226, [
                                                        _createElementVNode("div", _hoisted_227, [
                                                          _cache[96] || (_cache[96] = _createElementVNode("div", null, [
                                                            _createElementVNode("p", { class: "font-semibold text-xs text-justify" }, _toDisplayString('Updated The Status :'))
                                                          ], -1)),
                                                          _createElementVNode("div", _hoisted_228, [
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorFindingBg(work.additionalInfo.previousStatus)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(["text-xs", _ctx.colorFindingText(work.additionalInfo.previousStatus)])
                                                              }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.previousStatus)), 3)
                                                            ], 2),
                                                            _cache[95] || (_cache[95] = _createElementVNode("div", { class: "mx-4 flex items-center" }, [
                                                              _createElementVNode("img", { src: _imports_16 })
                                                            ], -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorFindingBg(work.additionalInfo.updatedStatus)])
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(["text-xs", _ctx.colorFindingText(work.additionalInfo.updatedStatus)])
                                                              }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.updatedStatus)), 3)
                                                            ], 2)
                                                          ])
                                                        ]),
                                                        ((work.additionalInfo.previousStatus == 10406 || work.additionalInfo.previousStatus == 10402) && (work.additionalInfo.updatedStatus == 10406 || work.additionalInfo.updatedStatus==10403) && work.additionalInfo.taskId)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_229, [
                                                              _cache[97] || (_cache[97] = _createTextVNode(" ID:")),
                                                              _createElementVNode("span", _hoisted_230, _toDisplayString(work.additionalInfo.taskId), 1),
                                                              _cache[98] || (_cache[98] = _createTextVNode(" is completed "))
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (tab.id == 4)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_231, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_232, [
                                      _cache[99] || (_cache[99] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("p", { class: "header" }, "Approvals")
                                        ])
                                      ], -1)),
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_233, [
                                          _createElementVNode("div", _hoisted_234, [
                                            _createElementVNode("button", {
                                              class: _normalizeClass(["flex", _ctx.causesLength == true || _ctx.approvalObj.statusCode == 10401 || _ctx.approvalObj.statusCode == 10403  || !_ctx.isAddDisabled(10302)? 'btndisabled  pointer-events-none' : 'filterButton']),
                                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openApprovalpopup()))
                                            }, " Send Approval ", 2)
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentFindingObject.approvals, (approval, number) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: number,
                                          class: "bg-white flex flex-row p-4 mb-0.5 border-lightgrey border-b w-full"
                                        }, [
                                          (approval.createdBy != undefined)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_235, _toDisplayString(_ctx.extractInitials(_ctx.getPersonName(approval.createdBy))), 1))
                                            : _createCommentVNode("", true),
                                          (approval.createdBy != undefined)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_236, _toDisplayString(_ctx.getPersonName(approval.createdBy)), 1))
                                            : _createCommentVNode("", true),
                                          (approval.updatedBy != undefined)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_237, _toDisplayString(_ctx.extractInitials(_ctx.getPersonName(approval.updatedBy))), 1))
                                            : _createCommentVNode("", true),
                                          (approval.updatedBy != undefined)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_238, _toDisplayString(_ctx.getPersonName(approval.updatedBy)), 1))
                                            : _createCommentVNode("", true),
                                          (approval.statusCode == 10401)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_239, _toDisplayString(' Requested an approval ')))
                                            : (approval.statusCode == 10410)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_240, _toDisplayString(' Rejected an approval ')))
                                              : (approval.statusCode == 10403)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_241, _toDisplayString(' Approved an approval ')))
                                                : _createCommentVNode("", true),
                                          (approval.createdAt != undefined)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_242, _toDisplayString(approval.createdAt), 1))
                                            : _createCommentVNode("", true),
                                          (approval.updatedAt != undefined)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_243, _toDisplayString(approval.updatedAt), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]),
            _createElementVNode("div", _hoisted_244, [
              _createElementVNode("div", _hoisted_245, [
                _cache[112] || (_cache[112] = _createElementVNode("div", { class: "pb-2 border-b border-lightgrey" }, [
                  _createElementVNode("h1", null, "Finding Details")
                ], -1)),
                (_ctx.tabDataLoading == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_246, [
                      _createElementVNode("div", _hoisted_247, [
                        _createVNode(_component_dots_loader)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_248, [
                      _createElementVNode("div", _hoisted_249, [
                        _cache[100] || (_cache[100] = _createElementVNode("label", { class: "controllabel" }, "Finding Status", -1)),
                        _createVNode(_component_Select, {
                          modelValue: _ctx.TaskDetailsDropDown.findingStatus,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.TaskDetailsDropDown.findingStatus) = $event)),
                          options: _ctx.statuses,
                          onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus))),
                          optionLabel: "label",
                          optionValue: "id",
                          class: _normalizeClass(["w-full no-interaction custom-select mt-2 border border-lightgrey", _ctx.changeBackground()])
                        }, null, 8, ["modelValue", "options", "class"])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_250, [
                          _cache[101] || (_cache[101] = _createElementVNode("label", { class: "controllabel" }, "Assignee", -1)),
                          (_ctx.TaskDetailsDropDown.taskStatus == 10403 || _ctx.presentFindingObject.statusCode == 10403 || _ctx.presentFindingObject.statusCode == 10418 || (_ctx.presentFindingObject.teamOwner != _ctx.userInfo._id && ( _ctx.newAssignee.value != _ctx.userInfo._id)))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_251, [
                                _createElementVNode("p", _hoisted_252, _toDisplayString(_ctx.newAssignee.label), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_253, [
                                _createVNode(_component_AutoComplete, {
                                  modelValue: _ctx.presentFindingObject.assignee,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.presentFindingObject.assignee) = $event)),
                                  suggestions: _ctx.userOptions,
                                  onComplete: _ctx.asyncFind,
                                  disabled: !_ctx.isAddDisabled(10302),
                                  onItemSelect: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateAssignedMember(_ctx.presentFindingObject.assignee))),
                                  optionLabel: "label",
                                  optionValue: "value",
                                  forceSelection: true,
                                  placeholder: "Assigned-To",
                                  class: "p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect"
                                }, null, 8, ["modelValue", "suggestions", "onComplete", "disabled"])
                              ]))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_254, [
                        _cache[102] || (_cache[102] = _createElementVNode("label", { class: "controllabel" }, "Reviewer", -1)),
                        _cache[103] || (_cache[103] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentFindingObject.reviewer != undefined || _ctx.presentFindingObject.reviewer != null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_255, _toDisplayString(_ctx.getPerson(_ctx.presentFindingObject.reviewer)), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_256, "N/A"))
                      ]),
                      (((_ctx.presentFindingObject.appId && _ctx.presentFindingObject.appId==10003)|| _ctx.presentFindingObject.treatmentType!=undefined))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_257, [
                            _cache[104] || (_cache[104] = _createElementVNode("label", { class: "controllabel mb-2" }, "Treatment Type", -1)),
                            _cache[105] || (_cache[105] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("div", {
                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2 mb-3", _ctx.treatmentTypeBgColor(_ctx.presentFindingObject.treatmentType)])
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["text-xs", _ctx.treatmentTypeTextColor(_ctx.presentFindingObject.treatmentType)])
                              }, _toDisplayString(_ctx.presentTask(_ctx.presentFindingObject.treatmentType)||'N/A'), 3)
                            ], 2)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_258, [
                        _cache[106] || (_cache[106] = _createElementVNode("label", { class: "controllabel" }, "Team Representative", -1)),
                        _cache[107] || (_cache[107] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentFindingObject.teamOwner != undefined || _ctx.presentFindingObject.teamOwner != null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_259, _toDisplayString(_ctx.getAllPersonName(_ctx.presentFindingObject.teamOwner)), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_260, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_261, [
                        _cache[108] || (_cache[108] = _createElementVNode("label", { class: "controllabel" }, "Team", -1)),
                        _cache[109] || (_cache[109] = _createElementVNode("br", null, null, -1)),
                        (_ctx.presentFindingObject.department != undefined || _ctx.presentFindingObject.department != null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_262, _toDisplayString(_ctx.getTeamName(_ctx.presentFindingObject.department)), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_263, "N/A"))
                      ]),
                      _createElementVNode("div", _hoisted_264, [
                        _cache[110] || (_cache[110] = _createElementVNode("label", { class: "controllabel" }, "Location", -1)),
                        _cache[111] || (_cache[111] = _createElementVNode("br", null, null, -1)),
                        (Object.keys(_ctx.presentFindingObject).includes('location') && _ctx.presentFindingObject.location!=undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_265, _toDisplayString(_ctx.presentFindingObject.location), 1))
                          : (Object.keys(_ctx.presentFindingObject).includes('location') && !Object.keys(_ctx.presentFindingObject).includes('entity') && _ctx.presentFindingObject.location != '' && _ctx.presentFindingObject.location != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_266, _toDisplayString(_ctx.getEntity(_ctx.presentFindingObject.location)), 1))
                            : (Object.keys(_ctx.presentFindingObject).includes('entity') && _ctx.presentFindingObject.entity != '' && _ctx.presentFindingObject.entity != null && _ctx.presentFindingObject.entity != undefined)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_267, _toDisplayString(_ctx.getEntity(_ctx.presentFindingObject.entity)), 1))
                              : (Object.keys(_ctx.presentFindingObject).includes('location') && _ctx.presentFindingObject.location==null && _ctx.presentFindingObject.department!='')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_268, _toDisplayString(_ctx.getLocationNameForSystem(_ctx.presentFindingObject.department)), 1))
                                : (_ctx.presentFindingObject.location==null)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_269, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationObject, (val) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: val._id
                                        }, [
                                          (val.entityType==1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_270, _toDisplayString(val?.label|| 'N/A'), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_271, "N/A"))
                      ])
                    ]))
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showCausePopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          popUp: _ctx.showCausePopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_272, [
              _cache[114] || (_cache[114] = _createElementVNode("h1", null, "Cause and Action", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onCrossbtnForCauseAndAction()))
              }, _cache[113] || (_cache[113] = [
                _createElementVNode("img", {
                  src: _imports_17,
                  class: "cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_273, [
              _createElementVNode("div", _hoisted_274, [
                _createElementVNode("div", _hoisted_275, [
                  _createElementVNode("div", _hoisted_276, [
                    _createElementVNode("div", _hoisted_277, [
                      _cache[115] || (_cache[115] = _createElementVNode("label", { class: "controllabel" }, "Cause", -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.causeActionObj.cause.$error }]),
                        type: "text",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.causeActionObj.cause) = $event)),
                        placeholder: "Cause for the Finding",
                        onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.v$.causeActionObj.cause.$touch()))
                      }, null, 34), [
                        [
                          _vModelText,
                          _ctx.causeActionObj.cause,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.causeActionObj.cause.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_278, [
                            (_ctx.v$.causeActionObj.cause.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_279, "Required"))
                              : (_ctx.v$.causeActionObj.cause.required && _ctx.v$.causeActionObj.cause.restrictCharacters100.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_280, "Charcter Limit is exceeded"))
                                : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_281, [
                    _createElementVNode("button", {
                      class: "btnprimary",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.addTextarea()))
                    }, "Add")
                  ]),
                  _cache[120] || (_cache[120] = _createElementVNode("label", { class: "controllabel" }, "Actions", -1)),
                  (_ctx.textareas.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_282, _cache[116] || (_cache[116] = [
                        _createElementVNode("div", { class: "error-text" }, "Enter atleast one Action", -1)
                      ])))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textareas, (textarea, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "mb-2"
                      }, [
                        _createElementVNode("div", _hoisted_283, [
                          _createElementVNode("div", _hoisted_284, [
                            _withDirectives(_createElementVNode("textarea", {
                              class: _normalizeClass(["inputboxstyling mt-2", {
                  'is-invalid borderRed':
                    _ctx.v$.textareas.$dirty &&
                    !_ctx.v$.textareas.$each.$response.$data[index].action.required,
                }]),
                              "onUpdate:modelValue": ($event: any) => ((textarea.action) = $event),
                              placeholder: "Add an action for this Cause",
                              rows: "3"
                            }, null, 10, _hoisted_285), [
                              [
                                _vModelText,
                                textarea.action,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (
                  _ctx.v$.textareas.$dirty &&
                  !_ctx.v$.textareas.$each.$response.$data[index].action.required
                )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_286, _cache[117] || (_cache[117] = [
                                  _createElementVNode("div", { class: "error-text" }, "Required", -1)
                                ])))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_287, [
                            _createElementVNode("div", _hoisted_288, [
                              _createElementVNode("img", {
                                src: _imports_14,
                                class: "cursor-pointer",
                                onClick: ($event: any) => (_ctx.clickedOnDeleteButton(index))
                              }, null, 8, _hoisted_289)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_290, [
                          _cache[119] || (_cache[119] = _createElementVNode("label", { class: "controllabel" }, "Target Date", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((textarea.targetDate) = $event),
                            type: "date",
                            class: _normalizeClass(["mt-2 w-1/2", {
                'inputboxstylingForSelectAtPopup': textarea.targetDate == '',
                'stylingForInputboxstylingForSelectAtPopup': textarea.targetDate != '',
                'is-invalid borderRed':
                  _ctx.v$.textareas.$dirty &&
                  _ctx.v$.textareas.$each.$response.$data[index] &&
                  _ctx.v$.textareas.$each.$response.$data[index].targetDate &&
                  !_ctx.v$.textareas.$each.$response.$data[index].targetDate.required,
              }]),
                            onFocus: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                            style: {"height":"28px"},
                            onkeydown: "return false",
                            max: _ctx.todayDate
                          }, null, 42, _hoisted_291), [
                            [_vModelText, textarea.targetDate]
                          ]),
                          (
                _ctx.v$.textareas.$dirty &&
                _ctx.v$.textareas.$each.$response.$data[index] &&
                _ctx.v$.textareas.$each.$response.$data[index].targetDate &&
                !_ctx.v$.textareas.$each.$response.$data[index].targetDate.required
              )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_292, _cache[118] || (_cache[118] = [
                                _createElementVNode("div", { class: "error-text" }, "Target Date is Required", -1)
                              ])))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[121] || (_cache[121] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                (!_ctx.editVariable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_293, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btnprimary mr-2", 
              JSON.stringify(_ctx.causeActionObj.cause) !=
                JSON.stringify(_ctx.causeActionObjDummy.cause) ||
              JSON.stringify(_ctx.textareas) != JSON.stringify(_ctx.textareasDummy)
                ? 'btnprimary'
                : 'btndisabled pointer-events-none'
            ]),
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.cancelCauseAction()))
                      }, " Reset ", 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(["btnprimary", 
              JSON.stringify(_ctx.causeActionObj.cause) !=
                JSON.stringify(_ctx.causeActionObjDummy.cause) &&
              JSON.stringify(_ctx.textareas) != JSON.stringify(_ctx.textareasDummy)
                ? 'btnprimary'
                : 'btndisabled pointer-events-none'
            ]),
                        disabled: _ctx.clickOnButtonForCause,
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.saveCauseAction()))
                      }, " Save ", 10, _hoisted_294)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.editVariable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_295, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btnprimary mr-2", 
              JSON.stringify(_ctx.causeActionObj.cause) !=
                JSON.stringify(_ctx.objDummy.cause) ||
              JSON.stringify(_ctx.textareas) !=
                JSON.stringify(_ctx.causeActionObj.actions)
                ? 'btnprimary'
                : 'btndisabled pointer-events-none'
            ]),
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.cancelEditedCauseAndAction()))
                      }, " Reset ", 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(["btnprimary", 
              JSON.stringify(_ctx.causeActionObj.cause) !=
                JSON.stringify(_ctx.objDummy.cause) ||
              (JSON.stringify(_ctx.textareas) !=
                JSON.stringify(_ctx.causeActionObj.actions) &&
                _ctx.textareas.length > 0)
                ? 'btnprimary'
                : 'btndisabled pointer-events-none'
            ]),
                        disabled: _ctx.clickOnButtonForCause,
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (
              _ctx.updateCauseAndAction(
                _ctx.causeIdOfCauseAndAction,
                _ctx.createdAtForUpdate,
                _ctx.createdByForUpdate
              )
            ))
                      }, " Save ", 10, _hoisted_296)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showApprovalPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.showApprovalPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_297, [
              _cache[123] || (_cache[123] = _createElementVNode("h1", null, "Approval", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onCrossbtn()))
              }, _cache[122] || (_cache[122] = [
                _createElementVNode("img", {
                  src: _imports_17,
                  class: "cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_298, [
              _createElementVNode("div", _hoisted_299, [
                _createElementVNode("div", _hoisted_300, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_301, [
                        _createElementVNode("div", _hoisted_302, [
                          _createElementVNode("div", _hoisted_303, [
                            _createElementVNode("div", _hoisted_304, [
                              _cache[124] || (_cache[124] = _createElementVNode("label", { class: "controllabel" }, "Name of the Authority", -1)),
                              _createElementVNode("div", _hoisted_305, _toDisplayString(_ctx.getPersonName(_ctx.presentFindingObject.reviewer)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_306, [
                            _createElementVNode("div", _hoisted_307, [
                              _cache[125] || (_cache[125] = _createElementVNode("label", { class: "controllabel" }, "Justification or Comments for Approving", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.taskObj.approvalComments.$error }]),
                                placeholder: "Comments",
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.taskObj.approvalComments) = $event)),
                                onInput: _cache[24] || (_cache[24] = ($event: any) => (_ctx.v$.taskObj.approvalComments.$touch()))
                              }, null, 34), [
                                [
                                  _vModelText,
                                  _ctx.taskObj.approvalComments,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.taskObj.approvalComments.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_308, [
                                    (_ctx.v$.taskObj.approvalComments.restrictCharacters300.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_309, "Charcter Limit is exceeded"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[126] || (_cache[126] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_310, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btnprimary mr-2", 
                _ctx.taskObj.approvalComments == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              ]),
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onCancelbtnAtApproval()))
                  }, " Reset ", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btnprimary", 
                _ctx.taskObj.approvalComments == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              ]),
                    disabled: _ctx.clickOnButton,
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.applyAuthority()))
                  }, " Save ", 10, _hoisted_311)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showRejectPopup)
      ? (_openBlock(), _createBlock(_component_popup, { key: 3 }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_312, [
              _cache[128] || (_cache[128] = _createElementVNode("h1", null, "Justification to Reject the Approval", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onCrossbtnToCloseRejectionPopup()))
              }, _cache[127] || (_cache[127] = [
                _createElementVNode("img", {
                  src: _imports_17,
                  class: "cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_313, [
              _createElementVNode("div", _hoisted_314, [
                _createElementVNode("div", _hoisted_315, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_316, [
                      _createElementVNode("div", _hoisted_317, [
                        _cache[129] || (_cache[129] = _createElementVNode("label", { class: "controllabel" }, "Justification", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.rejectJustification.justification.$error }]),
                          placeholder: "Comments",
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.rejectJustification.justification) = $event)),
                          onInput: _cache[29] || (_cache[29] = ($event: any) => (_ctx.v$.rejectJustification.justification.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.rejectJustification.justification,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.rejectJustification.justification.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_318, [
                              (_ctx.v$.rejectJustification.justification.restrictCharacters300.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_319, "Charcter Limit is exceeded"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[130] || (_cache[130] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_320, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btnprimary mr-2", 
            _ctx.rejectJustification.justification == ''? 'btndisabled pointer-events-none' : 'btnprimary']),
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.onCancelbtnToReject()))
                  }, " Reset ", 2),
                  _createElementVNode("button", {
                    disabled: _ctx.clickOnButtonToReject,
                    class: _normalizeClass(["btnprimary", 
            _ctx.rejectJustification.justification == ''? 'btndisabled pointer-events-none' : 'btnprimary'
          ]),
                    onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.approveOrReject(10410)))
                  }, " Save ", 10, _hoisted_321)
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}